import { FormItem, IFormItemProps } from '@framework/form';
import * as React from 'react';
import { FieldValues } from 'react-hook-form';
import { AdvancedSearchFormItemLayout } from './AdvancedSearchFormItemLayout';

export interface IAdvancedSearchFormItemProps<T extends FieldValues>
  extends IFormItemProps<T> {}

export function AdvancedSearchFormItem<T extends FieldValues>(
  props: IAdvancedSearchFormItemProps<T>,
) {
  return <FormItem layout={AdvancedSearchFormItemLayout} {...props} />;
}
